import api from './api';
import { User, Role } from '../types/auth.types';

export const UserService = {
  getAllUsers: async (): Promise<User[]> => {
    const response = await api.get<User[]>('/users');
    return response.data;
  },

  getUserById: async (id: string): Promise<User> => {
    const response = await api.get<User>(`/users/${id}`);
    return response.data;
  },

  createUser: async (userData: any): Promise<User> => {
    const response = await api.post<User>('/users', userData);
    return response.data;
  },

  updateUser: async (id: string, userData: any): Promise<User> => {
    const response = await api.put<User>(`/users/${id}`, userData);
    return response.data;
  },

  deleteUser: async (id: string): Promise<void> => {
    await api.delete(`/users/${id}`);
  },

  assignRole: async (userId: string, roleId: string): Promise<User> => {
    const response = await api.post<User>(`/users/${userId}/roles`, { roleId });
    return response.data;
  },

  removeRole: async (userId: string, roleId: string): Promise<User> => {
    const response = await api.delete<User>(`/users/${userId}/roles/${roleId}`);
    return response.data;
  },

  updateRoles: async (userId: string, roleIds: string[]): Promise<void> => {
    const response = await api.put(`/users/${userId}/roles`, { roleIds });
    return response.data;
  },

  getAllRoles: async (): Promise<Role[]> => {
    const response = await api.get<Role[]>('/users/roles');
    return response.data;
  },
};